// extracted by mini-css-extract-plugin
export var box = "_43-0";
export var check = "_43-1";
export var checkboxButton = "_43-6";
export var checkboxGroup = "_43-5";
export var disabled = "_43-7";
export var ghost = "_43-9";
export var input = "_43-2";
export var label = "_43-4";
export var normal = "_43-8";
export var uncheck = "_43-3";